import auth from '@/routes/middlewares/auth'
import permission from '@/routes/middlewares/permissions'
import verified from '@/routes/middlewares/verified'
import verify from '@/routes/middlewares/verify'


const NotFound = () =>
    import ( /* webpackChunkName: "notfound" */ '@/components/NotFound.vue');


const Dashboard = () =>
    import ( /* webpackChunkName: "dashboard" */ '@/pages/dashboard/Dashboard.vue');

const StationMedia = () =>
    import ( /* webpackChunkName: "station-media" */ '@/pages/media/StationMedia.vue');

const Playlists = () =>
    import ( /* webpackChunkName: "playlists" */ '@/pages/playlists/Playlists.vue');

const Schedules = () =>
    import ( /* webpackChunkName: "schedules" */ '@/pages/playlists/Schedules.vue');

const Overview = () =>
    import ( /* webpackChunkName: "overview" */ '@/pages/statistics/Overview.vue');


const Realtime = () =>
    import ( /* webpackChunkName: "statistics" */ '@/pages/statistics/Realtime.vue');


const Profile = () =>
    import ( /* webpackChunkName: "profile" */ '@/pages/users/Profile.vue');


const Settings = () =>
    import ( /* webpackChunkName: "settings" */ '@/pages/settings/Index.vue');

const Live = () =>
    import ( /* webpackChunkName: "live" */ '@/pages/live/Live.vue');

const StreamingControl = () =>
    import ( /* webpackChunkName: "streaming-control" */ '@/pages/streaming/StreamingControl.vue');

// const Users = () =>
//     import ( /* webpackChunkName: "users" */ '@/pages/users/Users.vue');




// const RolesPermissions = () =>
//     import ( /* webpackChunkName: "rolepermissions" */ '@/pages/users/Roles.vue');

// const Profile = () =>
//     import ( /* webpackChunkName: "profile" */ '@/pages/users/Profile.vue');

// const Edit = () =>
//     import ( /* webpackChunkName: "edit" */ '@/components/user/Edit.vue');



const VerifyToken = () =>
    import ( /* webpackChunkName: "verify-token" */ '@/components/authentication/VerifyToken.vue');

const Share = () =>
    import ( /* webpackChunkName: "share" */ '@/pages/share/Share.vue');


const routes = [

    {
        path: '/share',
        component: Share,
        meta: {
            title: 'Share',
            layout: 'default',
            middleware: [
                verified
            ]
        }

    },


    {
        path: '/verify-token',
        component: VerifyToken,
        meta: {
            title: 'verify-token',
            layout: 'no-nav',
            middleware: [
                verify
            ]
        }

    },




    //     {
    //         path: '/users',
    //         component: Users,
    //         meta: {
    //             middleware: [
    //                 verified,
    //                 permission('')

    //             ]
    //         },

    //     },

    //     {
    //         path: '/roles',
    //         component: RolesPermissions,
    //         meta: {
    //             middleware: [
    //                 verified,
    //                 permission('view_roles')

    //             ]
    //         },

    //     },


    //     {
    //         path: '/users/:user',
    //         component: Edit,
    //         name: 'user.show',
    //         meta: {
    //             middleware: [
    //                 verified
    //             ]
    //         },
    //     },


    {
        path: '/settings',
        name: 'settings',
        component: Settings,

        meta: {
            title: 'Settings',
            layout: 'default',
            middleware: [
                verified
            ]
        },

    },

    {
        path: '/profile',
        name: 'profile',
        component: Profile,

        meta: {
            title: 'Profile',
            layout: 'default',
            middleware: [
                verified
            ]
        },

    },


    {
        path: '/real-time',
        component: Realtime,
        meta: {
            title: 'Real Time',
            layout: 'default',
            middleware: [
                verified,

            ]
        },

    },

    {
        path: '/overview',
        component: Overview,
        meta: {
            title: 'Overview',
            layout: 'default',
            middleware: [
                verified,
            ]
        },

    },


    {
        path: '/schedules',
        component: Schedules,
        meta: {
            title: 'Schedules',
            layout: 'default',
            middleware: [
                verified,
            ]
        },
    },

    {
        path: '/go-live',
        component: Live,
        meta: {
            title: 'Go Live',
            layout: 'default',
            middleware: [
                verified,
            ]
        },
    },

    {
        path: '/streaming-control',
        component: StreamingControl,
        meta: {
            title: 'Streaming Control',
            layout: 'default',
            middleware: [
                verified,
            ]
        },
    },

    {
        path: '/playlists',
        component: Playlists,
        meta: {
            title: 'Playlists',
            layout: 'default',
            middleware: [
                verified,

            ]
        },

    },


    {
        path: '/files',
        component: StationMedia,
        meta: {
            title: 'Files',
            layout: 'default',
            middleware: [
                verified
            ]
        },
    },

    {
        path: '/',
        redirect: '/dashboard',
        meta: {
            title: 'Dashboard',
            middleware: [
                verified

            ]
        },
    },

    {
        path: '/dashboard',
        name: 'dashboard',
        // props: true,
        component: Dashboard,
        meta: {
            title: 'Dashboard',
            layout: 'default',
            middleware: [
                permission('view_dashboard'),
                verified
            ]
        },

    },

    { path: "*", component: NotFound }



]




export default routes

// export default routes.map(route => {
//   return { ...route, meta: { middleware: [auth, permission(route.component.name)] } }
// })